import { render, staticRenderFns } from "./OrderUpdateSuccessPage.vue?vue&type=template&id=335d9496"
import script from "./OrderUpdateSuccessPage.vue?vue&type=script&lang=js"
export * from "./OrderUpdateSuccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports